import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import { WebsiteJsonLd, OrganizationJsonLd } from '@/components/feature/JsonLd';
import { SITE_URL } from '@/constants/site';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <WebsiteJsonLd
        name="Vigorbuy Spread"
        url={SITE_URL}
        description="Your independent Vigorbuy Spreadsheet resource for organized product collections, QC photo guides and expert shopping tips."
      />
      <OrganizationJsonLd
        name="Vigorbuy Spread"
        url={SITE_URL}
        description="An independent informational platform providing educational resources, product guides, comparisons and shopping information related to Vigorbuy Spreadsheet."
        logo="https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg"
      />
      <Navbar />
      <main>
        <HeroSection />
        <SeoContent />
        <CategoryGrid />
      </main>
      <Footer />
    </div>
  );
}